export const pxPerKm = 1000;
export const hourPerSecond = 0.02;

export const scaleSpeedVisual = 20;
